const Backdrop = () => {
    return {
        MuiBackdrop: {
            styleOverrides: {
                invisible: {
                    backgroundColor: 'transparent'
                }
            }
        }
    }
}

export default Backdrop
